"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const getUrls = baseUrl => {
  const getUrl = url => "".concat(baseUrl).concat(url);

  return {
    SEND_SUPPORT_MESSAGE: getUrl('/v1/messaging/send-support-message')
  };
};

var _default = getUrls;
exports.default = _default;